module.exports = __webpack_public_path__ + "img/teams.44f2755e.svg";